(() => {
  angular
    .module('app')
    .controller('common.views.claim.process.editTicketItemModal', EditTicketItemController);

  EditTicketItemController.$inject = [
    '$uibModalInstance',
    'Hms.PatientTickets.PatientTicketItem',
    'treatmentItem',
    'currencyCode',
    'treatmentCategories',
    'treatmentMissed',
    'isTotalBillAmountValid',
    'treatmentHasValue',
  ];

  function EditTicketItemController(
    $uibModalInstance,
    constsPatientTicketItem,
    treatmentItem,
    currencyCode,
    treatmentCategories,
    treatmentMissed,
    isTotalBillAmountValid,
    treatmentHasValue
  ) {
    const vm = this;
    vm.loading = 0;
    vm.constsPatientTicketItem = constsPatientTicketItem;
    vm.currencyCode = currencyCode;
    vm.treatmentCategories = treatmentCategories;
    vm.treatmentMissed = treatmentMissed;
    vm.isTotalBillAmountValid = isTotalBillAmountValid;
    vm.treatmentHasValue = treatmentHasValue;
    vm.cancel = cancel;

    vm.item = {
      code: treatmentItem.code ?? '',
      coveredDescription: treatmentItem.coveredDescription ?? '',
      coveredAmount: treatmentItem.coveredAmount ?? 0,
      uncoveredDescription: treatmentItem.uncoveredDescription ?? '',
      uncoveredAmount: treatmentItem.uncoveredAmount ?? 0,
    };

    vm.cancel = cancel;
    vm.save = save;

    function save() {
      $uibModalInstance.close({
        ...vm.item,
      });
    }

    function cancel() {
      $uibModalInstance.dismiss();
    }
  }
})();
